module.exports = __webpack_public_path__ + "img/13_39.c29918e6.png";